module.exports = __webpack_public_path__ + "static/media/PNG-AVAX.ce51e396.png";